const ready = (callback) => {
	if (document.readyState !== "loading") {
		callback();
	} else {
		document.addEventListener("DOMContentLoaded", callback);
	}
};

ready(async () => {
	const mcForms = document.querySelectorAll(".nvw-block-mailchimp");

	for (const mcForm of mcForms) {
		mcForm.addEventListener("submit", async function (event) {
			event.preventDefault();

			const form = this;
			const firstNameField = mcForm.querySelector("#nvw-mce-FNAME");
			const emailField = mcForm.querySelector("#nvw-mce-EMAIL");
			const submitField = mcForm.querySelector("#nvw-embedded-subscribe");
			const submitFieldVal = submitField.value;
			const result = mcForm.querySelector(".nvw-subscribe-result");
			result.classList.remove("show");
			result.classList.add("hide");
			const data = new FormData(form);
			submitField.value = "Sending...";
			submitField.disabled = true;

			try {
				const response = await fetch(
					"/wp-json/nvw-blocks/v1/mailchimp-newsletter",
					{
						method: "POST",
						body: data,
						mode: "cors",
						credentials: "same-origin",
					}
				);

				const responseData = await response.json();

				submitField.value = submitFieldVal;

				result.classList.remove("hide");
				result.classList.add("show");

				if (responseData.result === "success") {
					firstNameField.style.borderColor = "var(--wp--preset--color--clear)";
					emailField.style.borderColor = "var(--wp--preset--color--clear)";
					result.style.color = "var(--wp--preset--color--pine)";
					result.innerHTML =
						"<p class='caption-paragraph'>Thank you for subscribing. We have sent you a confirmation email.</p>";
					firstNameField.value = "";
					emailField.value = "";
					submitField.disabled = false;
				} else {
					firstNameField.style.borderColor = "var(--wp--preset--color--tomato)";
					emailField.style.borderColor = "var(--wp--preset--color--tomato)";
					result.style.color = "var(--wp--preset--color--tomato)";
					result.innerHTML =
						"<p class='caption-paragraph'>" +
						responseData.msg.substring(4) +
						"</p>";
				}
			} catch (error) {
				submitField.value = submitFieldVal;
				submitField.disabled = false;
				console.error(error);
			}
		});
	}
});
